import { Injectable } from '@angular/core';

@Injectable()
export class ChartsService {

  constructor() { }

  masterChartOptions(colours = '', formatter) {

    return {
      chart: {
        spacing: [30, 20, 0, 20],
        style: {
          'fontFamily': 'Work Sans'
        }
      },
      colors: colours,
      credits: {
        enabled: false
      },
      legend: {
        itemStyle: {
          dominantBaseline: 'middle'
        },
        symbolPadding: 16,
        symbolWidth: 0
      },
      plotOptions: {
        line: {
          lineWidth: 1,
        },
        spline: {
          dataGrouping: {
            enabled: true,
            forced: true,
            smoothed: true,
            units: [[
              'second', [1]
            ]]
          },
          lineWidth: 1,
        },
        series: {}
      },
      series: [],
      title: {
        text: null
      },
      tooltip: {
        borderColor: '#999',
        formatter: formatter,
        shared: true
      },
      xAxis: {
        crosshair: true,
        type: 'datetime',
        dateTimeLabelFormats: {
          millisecond: '%H:%M:%S',
          second: '%H:%M:%S',
          minute: '%H:%M:%S',
          hour: '%H:%M:%S',
          day: '%H:%M:%S',
          week: '%H:%M:%S',
          month: '%H:%M:%S',
          year: '%H:%M:%S'
        },
        labels: {
          style: {
            'fontFamily': 'Apercu Mono Pro'
          }
        },
        plotLines: []
      },
      yAxis: [{
        labels: {
          align: 'left',
          format: '{value}W',
          style: {
            'fontFamily': 'Apercu Mono Pro'
          }
        },
        max: 0,
        plotBands: [],
        title: {
          style: {
            visibility: 'hidden'
          },
          text: null
        }
      }, {
        labels: {
          align: 'right',
          style: {
            'fontFamily': 'Apercu Mono Pro'
          }
        },
        max: 0,
        opposite: true,
        plotBands: [],
        title: {
          style: {
            visibility: 'visible'
          },
          text: 'Heart Rate/Cadence',
          x: 20
        }
      }],
    };
  }

  polarChartOptions() {

    return {
      chart: {
        polar: true,
        showAxes: false,
        spacing: [0, 0, 0, 0]
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          animation: false,
          enableMouseTracking: false,
          marker: {
            enabled: false
          }
        }
      },
      series: [],
      title: {
        text: null
      },
      xAxis: {
        max: 360,
        min: 0,
        reversed: true,
        tickInterval: 45,
        visible: false
      },
      yAxis: {
        min: 0,
        max: 0,
        tickInterval: 50,
        visible: false
      }
    };
  }

  revolutionChartOptions() {

    return {
      chart: {
        backgroundColor: 'transparent',
        polar: true,
        showAxes: true,
        spacing: [0, 0, 0, 0]
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          animation: false,
          enableMouseTracking: false,
          marker: {
            enabled: false
          }
        }
      },
      series: [],
      title: {
        text: null
      },
      xAxis: {
        gridLineColor: 'rgba(153, 153, 153, .25)',
        labels: {
          enabled: false
        },
        lineColor: '#555',
        max: 360,
        min: 0,
        reversed: true,
        tickInterval: 45
      },
      yAxis: {
        gridLineColor: 'rgba(153, 153, 153, .25)',
        labels: {
          format: '{value}N',
          style: {
            'color': '#999',
            'fontFamily': 'Apercu Mono Pro'
          }
        },
        max: 0,
        min: 0,
        tickInterval: 50
      }
    };
  }

  timeInZoneChartOptions(colors, formatter) {

    return {
      chart: {
        style: {
          'fontFamily': 'Work Sans'
        },
        type: 'column'
      },
      colors: colors,
      credits: {
        enabled: false
      },
      legend: {
        itemStyle: {
          dominantBaseline: 'middle'
        },
        symbolPadding: 16,
        symbolWidth: 0
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            formatter: formatter,
            style: {
              'fontFamily': 'Apercu Mono Pro'
            }
          },
          enableMouseTracking: false
        }
      },
      series: [],
      title: {
        text: null
      },
      tooltip: {
        enabled: false
      },
      xAxis: {
        categories: []
      },
      yAxis: {
        dateTimeLabelFormats: {
          millisecond: '%H:%M:%S',
          second: '%H:%M:%S',
          minute: '%H:%M:%S',
          hour: '%H:%M:%S',
          day: '%H:%M:%S',
          week: '%H:%M:%S',
          month: '%H:%M:%S',
          year: '%H:%M:%S'
        },
        endOnTick: false,
        labels: {
          enabled: false,
          style: {
            'fontFamily': 'Apercu Mono Pro'
          }
        },
        max: 0,
        tickInterval: 60000,
        title: {
          text: null
        },
        type: 'datetime'
      }
    }
  }

  legBalanceChartOptions() {

    return {
      chart: {
        spacing: [10, 0, 0, 0],
        type: 'pie'
      },
      colors: ['#555', '#00ebc2'],
      credits: {
        enabled: false
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        pie: {
          dataLabels: {
            distance: -50,
            enabled: true,
            format: '{y}%',
            style: {
              'fontFamily': 'Apercu Mono Pro'
            }
          },
          point: {
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          },
          showInLegend: true,
          slicedOffset: 0,
          size: '100%'
        },
        series: {
          enableMouseTracking: false,
        }
      },
      series: [],
      title: {
        text: null
      },
      tooltip: {
        enabled: false
      }
    }
  }

  legBalanceOverTimeChartOptions(formatter) {

    return {
      chart: {
        spacing: [10, 40, 0, 0],
        type: 'area'
      },
      colors: ['#555', '#00ebc2'],
      credits: {
        enabled: false
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        area: {
          events: {
            legendItemClick: function() {
              return false;
            }
          },
          lineColor: '#ffffff',
          lineWidth: 1,
          marker: {
            enabled: false
          },
          stacking: 'percent'
        }
      },
      series: [],
      title: {
        text: null
      },
      tooltip: {
        borderColor: '#999',
        formatter: formatter,
        shared: true
      },
      xAxis: {
        crosshair: true,
        dateTimeLabelFormats: {
          millisecond: '%H:%M:%S',
          second: '%H:%M:%S',
          minute: '%H:%M:%S',
          hour: '%H:%M:%S',
          day: '%H:%M:%S',
          week: '%H:%M:%S',
          month: '%H:%M:%S',
          year: '%H:%M:%S'
        },
        labels: {
          style: {
            'fontFamily': 'Apercu Mono Pro'
          }
        },
        plotLines: [],
        type: 'datetime'
      },
      yAxis: {
        labels: {
          format: '{value}%'
        },
        min: 0,
        max: 100,
        plotLines: [{
          color: '#ffffff',
          dashStyle: 'Dash',
          value: 48,
          width: 1,
          zIndex: 4
        }, {
          color: '#ffffff',
          dashStyle: 'Dash',
          value: 52,
          width: 1,
          zIndex: 4
        }],
        title: {
          enabled: false
        }
      }
    }
  }

  workoutProfileChart(profileArray, workoutType, plotLinesLaps) {

    let colours = {};
    let categories = [];

    const mmpColours = {
      0: '#99cdff',
      1: '#aedc92',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    const ftpColours = {
      0: '#99cdff',
      1: '#aedc92',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    if (workoutType == 'mmp') {
      workoutType = 'MMP';
      colours = mmpColours;
      categories = ["Recovery", "Zone 1", "Zone 2", "Zone 3", "Zone 4", "Zone 5", "Maximal", "Supra Maximal"];
    } else {
      workoutType = 'FTP';
      colours = ftpColours;
      categories = ["Active Recovery", "Endurance", "Tempo", "Lactate Threshold", "VO2max", "Anaerobic Capacity"];
    }

    // work out the tickInterval
    let tickInterval = 300;
    let durationTotal = 0;
    Object.keys(profileArray).forEach(function(key) {
      for (let i = 0; i < profileArray[key].length; i++) {
        if (profileArray[key][i][1]) {
          durationTotal += parseInt(profileArray[key][i][1]);
        }
      }
    });
    if (durationTotal < 600) {
      tickInterval = 30;
    } else if (durationTotal < 1800) {
      tickInterval = 150;
    } else if (durationTotal < 3600) {
      tickInterval = 600;
    } else {
      tickInterval = 1200;
    }

    var chart = {
      tooltip: { enabled: false },
      legend: { enabled: false },
      chart: {
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        height: 250
      },
      plotOptions: {
        series: {
          animation: false,
          marker: { enabled: false },
          states: { hover: { enabled: false } },
          lineWidth: 0,
          fillOpacity: 1
        }
      }
      ,
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        enabled: false
      },
      xAxis: [
        {
          tickInterval: tickInterval,
          endOnTick: false,
          title: {
            text: 'Time (Min)'
          },
          labels: {
            formatter: function() {
              let minutes = Math.floor(this.value / 60);
              let seconds = this.value - minutes * 60;
              return minutes + ':' + seconds;
              // return window['Highcharts'].dateFormat('%M:%S', this.value);
            }
          },
          plotLines: plotLinesLaps
        }
      ],
      yAxis: [
        {
          title: {
            text: '% ' + workoutType
          }
        }

      ],
      series: [
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[0],
          data: profileArray[0]
        },
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[1],
          data: profileArray[1]
        },
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[2],
          data: profileArray[2]
        },
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[3],
          data: profileArray[3]
        },
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[4],
          data: profileArray[4]
        },
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[5],
          data: profileArray[5]
        },
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[6],
          data: profileArray[6]
        },
        {
          showInLegend: false,
          type: "area",
          yAxis: 0,
          color: colours[7],
          data: profileArray[7]
        }
      ]
    };

    return chart;
  }

  workoutProfileChartNew(newHighchartsSeriesArray = null, workoutType, plotLinesLaps) {

    let colours = {};
    let categories = [];

    const mmpColours = {
      0: '#99cdff',
      1: '#aedc92',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    const ftpColours = {
      0: '#99cdff',
      1: '#aedc92',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    if (workoutType == 'mmp') {
      workoutType = 'MMP';
      colours = mmpColours;
      categories = ["Recovery", "Zone 1", "Zone 2", "Zone 3", "Zone 4", "Zone 5", "Maximal", "Supra Maximal"];
    } else {
      workoutType = 'FTP';
      colours = ftpColours;
      categories = ["Active Recovery", "Endurance", "Tempo", "Lactate Threshold", "VO2max", "Anaerobic Capacity"];
    }

    var chart = {
      tooltip: { enabled: false },
      legend: { enabled: false },
      chart: {
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        height: 250,
        type: 'area'
      },
      plotOptions: {
        area: {
          trackByArea: true,
          stickyTracking: false,
          events: {
            click: null
          }
        },
        series: {
          animation: false,
          marker: { enabled: false },
          states: { hover: { enabled: false } },
          lineWidth: 0,
          fillOpacity: 1,
          cursor: 'pointer',
        }
      }
      ,
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        enabled: false
      },
      xAxis: [
        {
          endOnTick: false,
          title: {
            text: 'Time (Min)'
          },
          labels: {
            formatter: function() {
              let minutes = Math.floor(this.value / 60);
              let seconds = this.value - minutes * 60;
              return minutes + ':' + seconds;
              // return window['Highcharts'].dateFormat('%M:%S', this.value);
            },
            style: {
              'fontFamily': 'Apercu Mono Pro'
            }
          },
          plotLines: plotLinesLaps
        }
      ],
      yAxis: [
        {
          labels: {
            style: {
              'fontFamily': 'Apercu Mono Pro'
            }
          },
          title: {
            text: '% ' + workoutType
          }
        }
      ],
      series: newHighchartsSeriesArray
    };

    return chart;
  }

  workoutZoneChart(zonePowerTimes, workoutType) {
    var stacking = false;
    var dataLabels = false;
    let colours = {};
    let categories = [];

    const mmpColours = {
      0: '#99cdff',
      1: '#aedc92',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    const ftpColours = {
      0: '#99cdff',
      1: '#aedc92',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    if (workoutType == 'mmp') {
      workoutType = 'MMP';
      colours = mmpColours;
      categories = ["Recovery", "Zone 1", "Zone 2", "Zone 3", "Zone 4", "Zone 5", "Maximal", "Supra Maximal"];
    } else {
      workoutType = 'FTP';
      colours = ftpColours;
      categories = ["Active Recovery", "Endurance", "Tempo", "Lactate Threshold", "VO2max", "Anaerobic Capacity"];
    }

    for (var i = 0; i < zonePowerTimes.length; i++) {
      zonePowerTimes[i] = zonePowerTimes[i] / 60; // convert seconds to minutes TODO: do this properly
    }

    var chart = {
      chart: {
        height: 250,
        type: 'column'
      },
      tooltip: {
        formatter: function() {
          if (this.y <= 1) {
            return this.y * 60 + ' secs';
          } else {
            return this.y + ' mins';
          }
        }
      },
      plotOptions: {
        column: {
          // stacking: stacking,
          dataLabels: {
            color: "white",
            style: {
              fontSize: 12,
              textShadow: "0 0 1px black"
            }
          }
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      title: {
        text: null
      },
      xAxis: {
        categories: categories
      },
      yAxis: {
        title: {
          text: "Minutes"
        }
      },
      series: [{
        name: "Minutes",
        data: zonePowerTimes,
        showInLegend: false
      }]

    };

    return chart;
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/charts.service.ts